module.exports = __webpack_public_path__ + "media/images/lb/777-92460aa398e9282602f5bf899a616eea.svg";